<div class="info-bar-container">
  <div class="info-bar-content">
    <div class="logo-container">
      <img
        class="oncodata_logo"
        alt="Oncodata Logo"
        src="images/oncodata_logo_gradient.png"
      />
    </div>

    <div
      class="command toggle-menu"
      (click)="toggleMenu()"
      *ngIf="isMobile"
      tabindex="0"
      #menuToggle
    >
      <i class="command tool-btn fa fa-bars"></i>
    </div>
    <div class="commands" #menu [ngClass]="{'mobile': isMobile, 'hidden': isMobile && !showingMenu}">
      <!--mat-icon is buggy and is cutting icons-->
      <!--<div class="command" [ngClass]="{'command-selected': currentSelected === labels.MY_EXAMS}"
                (click)="handleMyExamsSelected()" tabindex="0">
                <mat-icon class="command tool-btn" fontSet="fa" fontIcon="fa-list"></mat-icon>
                <span>{{ labels.MY_EXAMS }}</span>
            </div>
            <div *ngIf="enableDiscussion" class="command" [ngClass]="{'command-selected': currentSelected === labels.DISCUSSIONS}"
                (click)="handleDiscussionSelected()" tabindex="0">
                <mat-icon class="command tool-btn" fontSet="fa" fontIcon="fa-comments" matBadge="{{ nonReads > 0 ? nonReads : '' }}" matBadgeColor="warn"></mat-icon>
                <span>{{ labels.DISCUSSIONS }}</span>
            </div>
            <div class="command" [ngClass]="{'command-selected': currentSelected === labels.DATABASE}"
                (click)="handleDatabaseSelected()" tabindex="0">
                <mat-icon class="command tool-btn" fontSet="fa" fontIcon="fa-book"></mat-icon>
                <span>{{ labels.DATABASE }}</span>
            </div>
            <div *ngIf="enableRegisterCase" class="command" [ngClass]="{'command-selected': currentSelected === labels.REGISTER_CASE}"
                (click)="handleRegisterCaseSelected()" tabindex="0">
                <mat-icon class="command tool-btn" fontSet="fa" fontIcon="fa-user-pen"></mat-icon>
                <span>{{ labels.REGISTER_CASE }}</span>
            </div>
            <div *ngIf="isAdmin" class="command" [ngClass]="{'command-selected': currentSelected === labels.USER_MANAGEMENT}"
                (click)="handleUserManagementSelected()" tabindex="0">
                <mat-icon class="command tool-btn" fontSet="fa" fontIcon="fa-user-gear"></mat-icon>
                <span>{{ labels.USER_MANAGEMENT }}</span>
            </div>-->
      <div
        class="command"
        [ngClass]="{ 'command-selected': currentSelected === labels.MY_EXAMS }"
        (click)="handleMyExamsSelected()"
        tabindex="0"
      >
        <div class="command-content">
          <i class="command tool-btn fa fa-list"></i>
          <span>{{ labels.MY_EXAMS }}</span>
        </div>
      </div>
      <div
        *ngIf="enableDiscussion"
        class="command"
        [ngClass]="{
          'command-selected': currentSelected === labels.DISCUSSIONS
        }"
        (click)="handleDiscussionSelected()"
        tabindex="0"
      >
      <div class="command-content">
        <mat-icon
          class="command tool-btn"
          fontSet="fa"
          fontIcon="fa-comments"
          matBadge="{{ nonReads > 0 ? nonReads : '' }}"
          matBadgeColor="warn"
          aria-hidden="false"
        ></mat-icon>
        <span>{{ labels.DISCUSSIONS }}</span>
      </div>
      </div>
      <div
        *ngIf="enableImageDatabase"
        class="command"
        [ngClass]="{ 'command-selected': currentSelected === labels.DATABASE }"
        (click)="handleDatabaseSelected()"
        tabindex="0"
      >
      <div class="command-content">
        <i class="command tool-btn fa fa-book"></i>
        <span>{{ labels.DATABASE }}</span>
      </div>
        
      </div>
      <div
        *ngIf="enableRegisterCase"
        class="command"
        [ngClass]="{
          'command-selected': currentSelected === labels.REGISTER_CASE
        }"
        (click)="handleRegisterCaseSelected()"
        tabindex="0"
      >
      <div class="command-content">
        <i class="command tool-btn fa fa-user-pen"></i>
        <span>{{ labels.REGISTER_CASE }}</span>
      </div>
        
      </div>
      <div
        *ngIf="isAdmin"
        class="command"
        [ngClass]="{
          'command-selected': currentSelected === labels.USER_MANAGEMENT
        }"
        (click)="handleUserManagementSelected()"
        tabindex="0"
      >
      <div class="command-content">
        <i class="command tool-btn fa fa-user-gear"></i>
        <span>{{ labels.USER_MANAGEMENT }}</span>
      </div>
        
      </div>
      <div
        *ngIf="isAdmin"
        class="command"
        [ngClass]="{
          'command-selected': currentSelected === labels.INTEGRATION_LOG
        }"
        (click)="handleIntegrationLogSelected()"
        tabindex="0"
      >
      <div class="command-content">
        <i class="command tool-btn fa fa-gears"></i>
        <span>{{ labels.INTEGRATION_LOG }}</span>
      </div>
    </div>
    <div
        *ngIf="isAdmin && enableMonitorCase"
        class="command"
        [ngClass]="{
          'command-selected': currentSelected === labels.MONITOR_EXAMS
        }"
        (click)="handleMonitorCaseSelected()"
        tabindex="0"
      >
    <div class="command-content">
      <i class="command tool-btn fa fa-magnifying-glass"></i>
      <span>{{ labels.MONITOR_EXAMS }}</span>
    </div>
      
    </div>
    <div class="user-profile">
      <app-connect-status></app-connect-status>
      <app-user-profile-button [user]="user"></app-user-profile-button>
    </div>
  </div>
</div>
